/**
 * v-highlight
 * 高亮
 */
import type { Directive, DirectiveBinding } from "vue";

const highlight: Directive = {
    mounted(el: HTMLElement, binding: DirectiveBinding) {
        const { value } = binding;
        if (typeof value === "string") {
            const regex = new RegExp(value, "gi");
            // 获取节点中的文本内容
            const text = el.textContent || "";
            // 使用正则表达式替换文本中的匹配项，并添加高亮样式
            el.innerHTML = text.replace(regex, match => {
                return `<span style="color: #3370FF">${match}</span>`;
            });
        }
    }
};

export default highlight;
